<script setup lang="ts">
import { ref } from 'vue'

import { Modal } from '@collector/shared-ui'

withDefaults(
  defineProps<{
    title?: string
    confirmText?: string
    confirmDisabled?: boolean
  }>(),
  {
    title: 'Manual add incident',
    confirmText: 'Add incident',
  },
)

type Emits = { confirm: [] }
const emit = defineEmits<Emits>()

const isOpen = ref(false)

function open(): void {
  isOpen.value = true
}

function close(): void {
  isOpen.value = false
}
</script>

<template>
  <slot
    name="trigger"
    :open
  />
  <Modal
    v-if="isOpen"
    :title
    :confirmButton="{
      text: confirmText,
      confirm: () => emit('confirm'),
      disabled: confirmDisabled,
    }"
    @close="close"
  >
    <slot />
  </Modal>
</template>
